//angular imports
import { signal, WritableSignal, computed } from '@angular/core';

//third party imports
import { AccountInfo } from '@azure/msal-browser';

export class CurrentUserModel {
  
  public id?: string;
  public username: WritableSignal<string | null> = signal<string | null>(null);
  public firstName: WritableSignal<string | null> = signal<string | null>(null);
  public lastName: WritableSignal<string | null> = signal<string | null>(null);
  public email: WritableSignal<string | null> = signal<string | null>(null);
  public name: WritableSignal<string | null> = signal<string | null>(null);
  public avatar: WritableSignal<string | null> = signal<string | null>(null);
  
  public static readonly placeholderAvatarUrl = 'assets/images/user-placeholder.svg';
  
  public avatarUrl = computed(() => 
    this.avatar() ?? 
      CurrentUserModel.placeholderAvatarUrl);

  public static fromToken(account: AccountInfo): CurrentUserModel {
    const model = new CurrentUserModel();
    const claims = account?.idTokenClaims as Record<string, unknown> | undefined;

    model.id = CurrentUserModel.readClaim(claims, 'oid')
      ?? CurrentUserModel.readClaim(claims, 'objectId')
      ?? CurrentUserModel.readClaim(claims, 'sub')
      ?? account?.localAccountId;
    model.username.set(account?.username ?? CurrentUserModel.readClaim(claims, 'preferred_username') ?? null);
    model.firstName.set(CurrentUserModel.readClaim(claims, 'given_name') ?? null);
    model.lastName.set(CurrentUserModel.readClaim(claims, 'family_name') ?? null);
    model.email.set(
      CurrentUserModel.readClaim(claims, 'email')
      ?? CurrentUserModel.readClaim(claims, 'emails')
      ?? account?.username
      ?? null);
    model.name.set(account?.name ?? CurrentUserModel.readClaim(claims, 'name') ?? null);

    return model;
  }

  public handleImageError() {
      this.avatar.set(CurrentUserModel.placeholderAvatarUrl);
  }

  private static readClaim(claims: Record<string, unknown> | undefined, claimName: string): string | undefined {
    const value = claims?.[claimName];
    if (Array.isArray(value)) return value.find(item => typeof item === 'string') as string | undefined;
    return typeof value === 'string' ? value : undefined;
  }
}